import React from 'react';
import { InputRow } from '../../../helpers/uiComponents/InputRow';

class StepFive extends React.Component {
    render() {
        const doFunction = this.props.doFunction;
        return(
            <React.Fragment>
                <h4>5. Fill in the basic lead information and submit the test. Make sure to provide YOUR email address.</h4>
                <InputRow label="First Name" type="text" property="firstName" id="firstName" />
                <InputRow label="Last Name" type="text" property="lastName" id="lastName" />
                <InputRow label="YOUR Email*" type="text" property="email" id="email" />
                <InputRow label="Phone" type="text" property="phone" id="phone" />
                <InputRow label="Preferred Location" type="text" property="location" id="location" />
                <InputRow label="Postal Code" type="text" property="postalCode" id="postalCode" />

                <input
                    type="button"
                    onClick={() => doFunction()}
                    value="Submit Test"
                />

                <p id="send-message" style={{"textAlign": "center","color": "red"}}></p>
            </React.Fragment>
        )
    }
}
export default StepFive;


// WEBPACK FOOTER //
// ./src/component_crmTest/components/TestSteps/StepFive.js